<template>
  <UIPage
    class="localization"
    scrollable
  >
    <Tabs
      content-classes="localization__tab pb-2"
      :selected="selectedTab"
      :tabs="tabs"
      @select="selectTab"
    >
      <template #content-language>
        <LanguageTab />
      </template>
      <template #content-translation>
        <TranslationTab />
      </template>
    </Tabs>
  </UIPage>
</template>

<script>
import Tabs from "@shared/dashboard-components/tabs";
import {
  LanguageTab,
  TranslationTab,
} from "./components";
import { tabs } from "./utils/constants";

export default {
  name: "localization-admin",
  components: {
    Tabs,
    TranslationTab,
    LanguageTab,
  },
  props: {},
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    tabs() {
      return Object.values(tabs)
        .map((el) => ({
          ...el,
          label: this.$t(`pages.localization.${el.id}`),
        }));
    },
    selectedTab: {
      get() {
        return this.$route.query.tab || this.tabs[0]?.id;
      },
      set(value) {
        this.selectTab(value);
      },
    }
  },
  created() {
    this.selected = this.$route?.query?.tab || this.tabs[0]?.id;
  },
  methods: {
    selectTab(value) {
      this.$router.push({
        path: this.$route.path,
        query: {
          tab: value,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .localization {
    &__tab {
      flex-grow: 0;
      flex-basis: unset;
      overflow: visible;
    }
  }
}
</style>
